/**
 * @description 커스텀 웰로 서비스를 사용하는 서브 도메인 등록
 */
export enum SUB_DOMAIN {
  WELLO = 'www',
  WELLO_APP = 'app',
  KB_PAY = 'kbpay',
  TOSS = 'toss',
}
